// extracted by mini-css-extract-plugin
export default {"logo":"questionnaire_logo__qhowW","main":"questionnaire_main__1W85e","message":"questionnaire_message__-qmUn"};